import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observer } from 'mobx-react'

import TextInput from '../../shared/components/TextInput'
import Button from '../../shared/components/Button'

import fieldSpecs from '../fieldSpecs'

@observer
class FormPage extends Component {

  static defaultProps = {
    current: {}
  }

  static propTypes = {
    current: PropTypes.object,
    id: PropTypes.number,
    isBusy: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  }

  @autobind
  handleChange({ target }) {
    const {
      checked, type, value, name
    } = target
    const formData = { [name]: type === 'checkbox' ? checked : value }
    this.props.current.set(formData)
  }

  @autobind
  handleCancel(e) {
    e.preventDefault()
    if (this.props.onClose) {
      this.props.onClose(this.props.current)
    }
  }

  @autobind
  handleSave(e) {
    e.preventDefault()
    if (this.props.onSave) {
      this.props.onSave(this.props.current)
    }
  }

  render() {

    const { current } = this.props

    return (
      <div className="program vertical">
        <form
          className="form form-horizontal vertical"
          onSubmit={this.handleSave}
        >

          <h1>
            Einstellungen:
            {this.props.current.title}
          </h1>

          <TextInput
            name="hostelUrl"
            size={6}
            value={current.hostelUrl}
            isValid={current.validFields.hostelUrl}
            placeholder="http://url-der-jugendherberge.de"
            // helpText="(0 = ohne Einschränkung)"
            onChange={this.handleChange}
            {...fieldSpecs.hostelUrl}
          />

          <div className="form-group">

            <Button
              className="btn btn-default"
              type="button"
              onClick={this.handleCancel}
            >
              Abbrechen
            </Button>

            <Button
              className="action btn btn-primary pull-right"
              type="submit"
              onClick={this.handleSave}
              disabled={!current.validFields.hostelUrl.valid}
              icon="ok"
              busy={this.props.isBusy}
            >
              Speichern
            </Button>

          </div>

        </form>
      </div>
    )
  }
}

export { FormPage as default }



// WEBPACK FOOTER //
// ./src/program/components/AdminFormPage.js